import { useState } from 'react';
import { Box } from 'theme-ui';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Picture, Svg } from '@snippets';

import { ThumbsNavigation } from './ThumbsNavigation';
import { themed } from './Thumbs.theme';

export const Thumbs = themed(({ theme, medias, activeIndex, goToSlide }) => {
  const [swiper, setSwiper] = useState();

  return (
    <Box data-comp={Thumbs.displayName} sx={theme.thumbs}>
      <Swiper
        onSwiper={setSwiper}
        slidesPerView={5}
        direction="vertical"
        spaceBetween={12}
        preventClicksPropagation={false}
        preventClicks={false}
        watchOverflow
        grabCursor={medias?.length > 5}
        breakpoints={{
          1280: {
            slidesPerView: 6,
            grabCursor: medias?.length > 6,
          },
        }}
        sx={theme.swiper}
      >
        {medias?.map((media, index) => {
          const isActive = activeIndex === index;
          const image = media?.image || media?.preview?.image;
          const isVideo = media?.mediaContentType === 'VIDEO';
          const src = image?.originalSrc;
          return (
            <SwiperSlide key={index}>
              <Box
                data-comp="Thumb"
                onClick={() => goToSlide(index)}
                role="button"
                tabIndex="-1"
                aria-hidden="true"
                sx={{
                  ...theme.thumb,
                  ...(isActive ? theme.thumb.active : theme.thumb.inactive),
                }}
              >
                <Picture
                  alt={media.alt}
                  width={156}
                  height={156}
                  images={[{ src, ratio: 1, width: 100 }]}
                />

                {isVideo && (
                  <Svg
                    alt="play"
                    src="/svgs/play.svg#play"
                    viewBox="0 0 38 38"
                    sx={theme.play}
                  />
                )}
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <ThumbsNavigation swiper={swiper} count={medias?.length || 0} />
    </Box>
  );
});

Thumbs.displayName = 'Thumbs';
